export const cpoProgramDetailKeys: Record<string, string[]> = {
  acura: ['acura.detail0', 'acura.detail1', 'acura.detail2', 'acura.detail3'],
  ford: ['ford.detail0', 'ford.detail1', 'ford.detail2', 'ford.detail3'],
  gm: ['gm.detail0', 'gm.detail1', 'gm.detail2', 'gm.detail3'],
  honda: ['honda.detail0', 'honda.detail1', 'honda.detail2'],
  kia: ['kia.detail0', 'kia.detail1', 'kia.detail2', 'kia.detail3', 'kia.detail4'],
  lexus: ['lexus.detail0', 'lexus.detail1', 'lexus.detail2', 'lexus.detail3'],
  lincoln: ['lincoln.detail0', 'lincoln.detail1', 'lincoln.detail2', 'lincoln.detail3'],
  mazda: ['mazda.detail0', 'mazda.detail1', 'mazda.detail2', 'mazda.detail3', 'mazda.detail4'],
  nissan: [
    'nissan.detail0',
    'nissan.detail1',
    'nissan.detail2',
    'nissan.detail3',
    'nissan.detail4',
    'nissan.detail5',
    'nissan.detail6',
  ],
  porsche: ['porsche.detail0', 'porsche.detail1', 'porsche.detail2', 'porsche.detail3'],
  toyota: ['toyota.detail0', 'toyota.detail1', 'toyota.detail2', 'toyota.detail3'],
  volkswagen: ['volkswagen.detail0', 'volkswagen.detail1', 'volkswagen.detail2'],
  volvo: ['volvo.detail0', 'volvo.detail1', 'volvo.detail2', 'volvo.detail3', 'volvo.detail4'],
}
